<template>
  <v-app>
    <v-main>
      <v-card class="mx-auto mt-16 app-card" max-width="600" outlined>
        <template v-if="isValid">
          <v-card-title class="pb-0">
            {{ appointment.title }}
          </v-card-title>

          <div
            class="transition-container"
            :style="{
              height: `${currentStep === '2' ? 400 : 180}px`,
            }"
          >
            <transition name="fade">
              <router-view></router-view>
            </transition>
          </div>

          <v-card-actions class="mt-5">
            <v-spacer></v-spacer>
            <v-btn @click="prev" text :disabled="!appointment.prev">Prev</v-btn>
            <v-btn @click="next" color="primary" :disabled="!appointment.next">{{
              currentStep === '3' ? 'Confirm' : 'Next'
            }}</v-btn>
          </v-card-actions>
        </template>
        <template v-else>
          <v-card-title class="not-found">
            <h1 class="text-center mx-auto mt-16 error--text">
              {{ appointment.memberId ? 'Provider' : 'Member' }} ID not found.
            </h1>
            <small class="mb-16"> Please try again. </small>
          </v-card-title>
        </template>
      </v-card>
    </v-main>
    <v-snackbar color="success" :value="snackbar" right top :timeout="4000">
      Your appointment has been scheduled
    </v-snackbar>
  </v-app>
</template>
<style>
.not-found {
  flex-direction: column;
}

.app-card {
  overflow: hidden;
}

.transition-container {
  position: relative;
}

.fade-enter-active,
.fade-leave-active {
  left: 0;
  opacity: 1;
  position: absolute;
  top: 0;
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

body,
.v-application {
  font-family: 'Montserrat', sans-serif !important;
}
</style>
<script>
import moment from 'moment';

import { APPOINTMENT_DURATION } from './constants/appointment';
import { DATE_FORMAT } from './constants/moment';
import ADD_APPOINTMENT from './graphql/Query/AddAppointment.gql';

export default {
  name: 'App',
  components: {},
  data: () => ({
    currentStep: '1',
    loading: false,
    snackbar: false,
    isValid: false,
  }),
  mounted() {
    // Check url has the necessary info /?memberId=SOMETHING&providerId=SOMETHING
    const { memberId = null, providerId = null } = this.$route.query;
    this.isValid = memberId && providerId;
    this.$store.commit('updateAppointment', { providerId, memberId });

    // Go to first step
    const newStep = this.$router.history.current.path.replace('/', '') || '1';
    this.currentStep = newStep;
    this.stepCheck(newStep);
  },
  methods: {
    stepCheck(step) {
      const { type, date, time, environment } = this.appointment;
      const appointmentUpdate = { next: false, prev: false };

      switch (step) {
        case '1':
          break;

        case '2':
          if (!type || !environment) {
            this.$router.push('/1');
            return;
          }

          appointmentUpdate.prev = true;
          break;

        case '3':
          if (!type || !environment) {
            this.$router.push('/1');
            return;
          }

          if (!time || !date) {
            this.$router.push('/2');
            return;
          }

          appointmentUpdate.prev = true;
          appointmentUpdate.next = true;
          break;

        default:
          this.$router.push('/1');
          return;
      }

      this.$store.commit('updateAppointment', appointmentUpdate);
    },
    next() {
      if (Number(this.currentStep) === 3) {
        this.createAppointment();
        return;
      }
      this.$router.push(`/${Number(this.currentStep) + 1}`);
    },
    prev() {
      this.$router.push(`/${Number(this.currentStep) - 1}`);
    },
    async createAppointment() {
      const { date, environment, type, time } = this.$store.state.appointment;
      const duration = APPOINTMENT_DURATION[environment][type];

      this.snackbar = false;
      this.loading = true;

      await this.$apollo.mutate({
        mutation: ADD_APPOINTMENT,
        variables: {
          memberId: this.appointment.memberId,
          providerId: this.appointment.providerId,
          // @TODO These need to be dynamic
          employeeId: '1',
          startTime: moment.unix(time).unix(),
          endTime: moment.unix(time).add(duration, 'minutes').unix(),
          date: moment(date, DATE_FORMAT).unix(),
          status: 'pending',
        },
      });

      this.$store.dispatch('resetAppointment');
      this.$router.push('/1');

      this.loading = false;
      this.snackbar = true;
    },
  },
  computed: {
    appointment() {
      return this.$store.state.appointment;
    },
  },
  watch: {
    $route(to) {
      const newStep = to.path.replace('/', '') || '1';
      this.currentStep = newStep;
      this.stepCheck(newStep);
    },
  },
};
</script>
